import { observable, action, computed } from 'mobx';
import { Accounting } from 'api';

class AccountingStore {
  @observable.ref reports = [];

  @observable fetchState;

  anketId;

  @computed
  get accountingYears() {
    return this.reports.map(report => report.year);
  }

  @computed
  get allAccountCodes() {
    return this.reports.reduce((acc, annualReport) => {
      const { year, ...forms } = annualReport;

      const newForms = Object.values(forms).reduce((formsAcc, form) => {
        const newFormContent = form.reduce((formContent, formRow) => {
          const { code, name, endValue } = formRow;

          const row = formContent[code];
          const newFormRow = row ? { ...row, [year]: endValue } : { name, code, [year]: endValue };

          return { ...formContent, [code]: newFormRow };
        }, formsAcc);

        return { ...formsAcc, ...newFormContent };
      }, acc);

      return { ...acc, ...newForms };
    }, {});
  }

  @action.bound
  async getAccounting(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Accounting.getAccounting(anketId);
      this.reports = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const accoutingStatementsStore = new AccountingStore();

export default accoutingStatementsStore;
